import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import jsonGet from '../../../util/jsonGet';

import Button from '../Atoms/Button';
import Loading from '../Core/Loading';
import NewsItem from './NewsItem';
import { addCultureToParamsFromLocalStorage } from '../../../util/culture';

const propTypes = exact({
  apiURL: PropTypes.string.isRequired,
  loadMoreCtaButtonText: PropTypes.string,
  noResultsMessage: PropTypes.string,
  resultCtaButtonText: PropTypes.string,
  resultsPerPage: PropTypes.number,
  siteId: PropTypes.number.isRequired,
});

const defaultProps = {
  loadMoreCtaButtonText: 'Load More',
  noResultsMessage: 'Sorry, there are no news articles',
  resultCtaButtonText: 'Read More',
  resultsPerPage: 10,
};

class NewsListing extends Component {
  constructor(props) {
    super(props);

    this.handlePaginationClick = this.handlePaginationClick.bind(this);

    this.state = {
      items: [],
      isLoading: false,
      pageIsLoading: true,
    };
  }

  componentDidMount() {
    this.loadResults();
  }

  loadResults(value) {
    this.setState({ isLoading: true });

    const options = value || {};
    options.page = options.page || 1;
    options.resultsPerPage = this.props.resultsPerPage;
    options.siteId = this.props.siteId;
    const optionsWithLanguageCultureAdded = addCultureToParamsFromLocalStorage(options);

    jsonGet(this.props.apiURL, optionsWithLanguageCultureAdded, (data) => {
      if (data.errorCode) {
        return this.setState({
          items: [],
          page: options.page,
          totalItemCount: 0,
          isLoading: false,
          pageIsLoading: false,
        });
      }

      const currentItems = this.state.items || [];
      const items = currentItems.concat(data.items);

      return this.setState({
        items,
        page: options.page,
        totalItemCount: data.totalItemCount,
        isLoading: false,
        pageIsLoading: false,
      });
    });
  }

  handlePaginationClick() {
    this.loadResults({ page: this.state.page + 1 });
  }

  render() {
    return (
      <div className="NewsListing">
        {this.state.pageIsLoading && (
          <div className="NewsListing_loading">
            <Loading />
          </div>
        )}
        {this.state.items.length === 0 && !this.state.pageIsLoading && (
          <div className="NewsListing_noResults">{this.props.noResultsMessage}</div>
        )}
        {this.state.items.length > 0 && !this.state.pageIsLoading && (
          <>
            <ul className="NewsListing_list">
              {this.state.items.map((item) => (
                <li className="NewsListing_item" key={item.key}>
                  <NewsItem {...item} ctaButtonText={this.props.resultCtaButtonText} />
                </li>
              ))}
            </ul>
            {this.state.items.length < this.state.totalItemCount && (
              <div className="NewsListing_pagination">
                <Button
                  buttonType="button"
                  handleClick={this.handlePaginationClick}
                  isLoading={this.state.isLoading}
                  modifier="ghost"
                  text={this.props.loadMoreCtaButtonText}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

NewsListing.propTypes = propTypes;
NewsListing.defaultProps = defaultProps;

export default NewsListing;
